export const navigation = {
  chat: "Chat",
  newChat: "New Chat",
  chatHistory: "Chat History",
  login: "Login",
  settings: "Settings",
};
